import { Button, Card, CardContent, CardHeader, Grid, InputAdornment, TextField, Typography } from "@material-ui/core";
import FileCopyIcon from '@material-ui/icons/FileCopy';
import React, { useState, useEffect } from "react";
import { QRCode } from 'react-qrcode-logo';
import toastr from "toastr";
import "toastr/build/toastr.css";
import AutorenewIcon from '@material-ui/icons/Autorenew';
import { Alert, AlertTitle } from '@material-ui/lab';
import jwt_decode from "jwt-decode";
import Timer from "./timer";
import $ from "jquery";
const TronGrid = require('trongrid');
const TronWeb = require('tronweb');
var sourceAddress = "";
var currency = "";
let orgAmount = 0;
let transInfo = {};
var curScriptId = "Waiting For Payment";
var ackId = '';
var successUrl = "";
var failureUrl = "";
var transactionCharge = 0;

function Dashboard() {
    const urlParams = new URLSearchParams(window.location.search);
    const tokenInfo = urlParams.get('token');
    const dataInfo = urlParams.get('data');
    let seconds = 0;
    try {
        transInfo = jwt_decode(tokenInfo);
        let curAddress = jwt_decode(dataInfo);
        sourceAddress = curAddress.address;
        successUrl = transInfo.successUrl;
        failureUrl = transInfo.failureUrl;
        currency = transInfo.type;
        transactionCharge = curAddress.transactionCharge;
        orgAmount = currency.toLowerCase() === 'trx' ? parseFloat(curAddress.coins).toFixed(6) : curAddress.coins;
        ackId = curAddress.ackId;
        const stratTime = Date.now() / 1000; // use UNIX timestamp in seconds
        const endTime = transInfo.exp; // use UNIX timestamp in seconds
        seconds = endTime - stratTime;
    }
    catch (e) {
        console.log(e);
    }

    const [transactionId, setTransactionId] = useState("Waiting For Payment");
    const [status, setStatus] = useState("Waiting For Payment");
    const [amount, setAmount] = useState(orgAmount);
    const [timeLeft, setTimeLeft] = useState(seconds);

    useEffect(() => {
        if (orgAmount !== 0 && currency.toLowerCase() === "btc") {
            var ws = new WebSocket("wss://ws.smartbit.com.au/v1/blockchain");
            //var ping = pinger(ws);

            ws.onmessage = function (event) {
                let curData = JSON.parse(event.data);
                switch (curData.type) {
                    case 'subscribe-response':
                        log("Transaction linked with block chain. Please make payment soon");
                        break;
                    case 'heartbeat':
                        log("We are waiting for your payment");
                        break;
                    case 'address':
                        log("We got some transaction event. We are verifying.");
                        break;
                    default:
                        log(event.data);
                        break;
                }

                if (curData.type === "address") {
                    if (curData.payload && curData.payload.transaction) {
                        if (curData.payload.transaction.confirmations <= 0) {
                            let isExists = curData.payload.transaction.outputs.filter((x) => x.addresses.indexOf(sourceAddress) > -1);
                            if (isExists.length > 0) {
                                let confromAmt = isExists[0].value;
                                if (confromAmt.toString() === orgAmount.toString()) {
                                    setAmount(confromAmt);
                                    curScriptId = curData.payload.transaction.txid;
                                    setTransactionId(curData.payload.transaction.hash);
                                    fetch(process.env.REACT_APP_API + ackId + '?hash=' + curData.payload.transaction.hash, {
                                        method: 'PUT',
                                        headers: {
                                            'Authorization': 'Bearer ' + tokenInfo
                                        }
                                    });

                                    toastr.success("Transaction Initiated Waiting for the Block Chain to Confirm");
                                    setStatus("Transaction Initiated Waiting for the Block Chain to Confirm");
                                    //ping.stop();
                                    ws.send(JSON.stringify({ type: "address", address: sourceAddress, unsubscribe: true }));
                                    ws.close();
                                }
                            }
                        }
                    }
                }
            }

            ws.onopen = function (event) {
                ws.send(JSON.stringify({ type: "address", address: sourceAddress }));
            }
        }
        else if (orgAmount !== 0 && currency.toLowerCase() === "trx") {
            log("Transaction linked with block chain. Please make payment soon");
            const tronWeb = new TronWeb({
                fullHost: 'https://api.trongrid.io'
            });
            log("We are waiting for your payment");

            const tronGrid = new TronGrid(tronWeb);
            tronGrid.setExperimental("fea96e40-0ac2-4e2a-a9d3-babcec429421");

            let counter = 1;


            let cnt = setInterval(async () => {
                counter++;
                if (counter === 28) {
                    clearInterval(cnt);
                }
                await getTransactions();
                log("We are waiting for your payment");
            }, 20000)

            async function getTransactions() {
                const address = sourceAddress;

                const options = {
                    onlyTo: true,
                    limit: 10,
                    orderBy: 'timestamp,asc',
                    minBlockTimestamp: Date.now() - 60000 // from a minute ago to go on
                };

                // promise
                tronGrid.account.getTransactions(address, options).then(transactions => {
                    transactions.data.forEach((tran) => {
                        tran.raw_data.contract.forEach((ct) => {
                            if ((ct.parameter.value.amount / 1000000).toFixed(6) === parseFloat(orgAmount).toFixed(6)) {
                                clearInterval(cnt);
                                log("We got some transaction event. We are verifying.");
                                setAmount(parseFloat(orgAmount).toFixed(6));
                                curScriptId = tran.txID;
                                setTransactionId(tran.txID);
                                fetch(process.env.REACT_APP_API + ackId + '?hash=' + tran.txID + '&fromAddress=' + tronWeb.address.fromHex(ct.parameter.value.owner_address), {
                                    method: 'PUT',
                                    headers: {
                                        'Authorization': 'Bearer ' + tokenInfo
                                    }
                                });

                                toastr.success("Transaction Initiated Waiting for the Block Chain to Confirm");
                                setStatus("Transaction Initiated Waiting for the Block Chain to Confirm");
                                return;
                            }
                        })
                    })
                }).catch(err => console.error(err));
            }


        }
    }, []);

    if (orgAmount === 0) {
        return <Alert severity="error">
            <AlertTitle>Error</AlertTitle>
            You are Not Authorised to View this Page — <strong>check it out!</strong>
        </Alert>;
    }

    if (transactionId === "Waiting For Payment" && timeLeft <= 0) {
        var form = $('<form action="' + failureUrl + '" method="post">' +
            '<input type="text" name="token" value="' + tokenInfo + '" />' +
            '</form>');
        $('body').append(form);
        form.submit();
        return <Alert severity="error">
            <AlertTitle>Error</AlertTitle>
            Session Expired — <strong>check it out!</strong>
        </Alert>;
    }

    if (transactionId !== "Waiting For Payment") {
        setTimeout(() => {
            var form = $('<form action="' + successUrl + '" method="post">' +
                '<input type="text" name="token" value="' + tokenInfo + '" />' +
                '<input type="text" name="transactionHash" value="' + transactionId + '" />' +
                '<input type="text" name="transactionId" value="' + transInfo.txnid + '" />' +
                '<input type="text" name="referenceNo" value="' + ackId + '" />' +
                '</form>');
            $('body').append(form);
            form.submit();
        }, 5000)
        if (currency.toLowerCase() === "btc") {
            return <Alert severity="success">
                <AlertTitle>Payment Success</AlertTitle>
                Your Transaction is Confirmed with transaction hash&nbsp;&nbsp;&nbsp;
                <a style={{ color: "white", wordBreak: "break-word" }}
                    href={"https://www.blockchain.com/btc/tx/" + transactionId}>{transactionId}</a>
                <br /><strong>For more information&nbsp;&nbsp;&nbsp;
                    <a style={{ color: "white" }}
                        href={"https://www.blockchain.com/btc/tx/" + transactionId}>Click Here</a>
                </strong>
            </Alert>;
        }
        else {
            return <Alert severity="success">
                <AlertTitle>Payment Success</AlertTitle>
                Your Transaction is Confirmed with transaction hash&nbsp;&nbsp;&nbsp;
                <a style={{ color: "white", wordBreak: "break-word" }}
                    href={"https://tronscan.org/#/transaction/" + transactionId}>{transactionId}</a>
                <br /><strong>For more information&nbsp;&nbsp;&nbsp;
                    <a style={{ color: "white" }}
                        href={"https://tronscan.org/#/transaction/" + transactionId}>Click Here</a>
                </strong>
            </Alert>;
        }
    }


    function log(msg) {
        console.log(msg);
        var node = document.createElement("LI");
        if (node) {             // Create a <li> node
            var textnode = document.createTextNode(msg);
            if (node && node.appendChild) {    // Create a text node
                node.appendChild(textnode);
            }
            if (document.getElementById("log")) {
                document.getElementById("log").appendChild(node);
            }
        }
    }

    // function pinger(ws) {
    //     var timer = setInterval(function () {
    //         if (ws.readyState == 1) {
    //             ws.send(JSON.stringify({ op: "ping" }));
    //         }
    //     }, 5000);
    //     return { stop: function () { clearInterval(timer); } };
    // }

    function copyText() {
        var copyText = document.getElementById("myInput");

        /* Select the text field */
        copyText.select();
        copyText.setSelectionRange(0, 99999); /* For mobile devices */

        /* Copy the text inside the text field */
        document.execCommand("copy");
        toastr.success("Link Copied to Clipboard");
    }

    return (
        <Card>
            <CardHeader title={"Coins : " + amount + " " + currency}
                subheader={"Transaction Status : " + transactionId} />
            <CardContent>

                <Grid container>
                    <Grid item md={6} sm={12} xs={12} style={{ "textAlign": "center" }}>
                        {
                            timeLeft > 300 ?
                                <>
                                    <QRCode value={currency.toLowerCase() === "btc" ? "bitcoin:" : "" + sourceAddress + "?amount=" + amount + "&label=payment"} />
                                    <TextField
                                        variant="standard"
                                        fullWidth
                                        value={sourceAddress}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <FileCopyIcon htmlColor="#b27919" onClick={() => copyText()} />
                                                </InputAdornment>
                                            ),
                                        }}
                                        inputProps={{
                                            "aria-readonly": true,
                                            id: "myInput"
                                        }} />
                                    <Typography variant="h4" component="p">
                                        Or
                                    </Typography>
                                    <br />
                                    <div>
                                        <a
                                            target="_blank"
                                            className="btn"
                                            href={`https://link.trustwallet.com/send?coin=195&address=${sourceAddress}&amount=${amount}`}>
                                            Pay Using Trust Wallet
                                        </a>
                                    </div>
                                </> :
                                <>
                                    <Alert severity="warning" style={{ textAlign: "left" }}>
                                        <AlertTitle>Transaction Status</AlertTitle>
                                        If Payment is already done by you, <strong>Please wait for some time for confirmations.</strong>
                                    </Alert>
                                    <br />
                                    <br />
                                    <Alert severity="error" style={{ textAlign: "left" }}>
                                        <AlertTitle>Skip Payment</AlertTitle>
                                        <a href={failureUrl}>Click Here</a><strong> to leave the page without payment.</strong>
                                    </Alert>
                                </>
                        }

                        {
                            status === "Transaction Confirmed By Block Chain" ?
                                <Alert severity="success">
                                    <AlertTitle>Success</AlertTitle>
                                    Transaction Confirmed — <strong>check it out!</strong>
                                </Alert>
                                :
                                <div>
                                    <br />
                                    <br />
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                        startIcon={<AutorenewIcon />}
                                    >
                                        {status}
                                    </Button>
                                    <br />
                                    <br />
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        color="secondary"
                                        startIcon={<AutorenewIcon />}
                                    >
                                        {curScriptId}
                                    </Button>
                                </div>
                        }
                    </Grid>
                    <Grid item md={6} sm={12} xs={12}>
                        <ul className="details">
                            <li><label>Name: </label><b>{transInfo.name}</b></li>
                            <li><label>Deposit Amount:  </label><b>{(parseFloat(orgAmount) - parseFloat(transactionCharge)).toFixed(currency.toUpperCase() === "TRX" ? 6 : 8)} {currency.toUpperCase()}</b></li>
                            <li><label>Transaction Charge :  </label><b>{parseFloat(transactionCharge).toFixed(currency.toUpperCase() === "TRX" ? 6 : 8)} {currency.toUpperCase()}</b></li>
                            <li><label>Customer ID:  </label><b>{transInfo.cid}</b></li>
                            <li><label>Email:  </label><b>{transInfo.email}</b></li>
                            <li><label>Mobile No: </label><b>{transInfo.mobile}</b></li>
                            <li><label>Reference No: </label><b>{transInfo.txnid}</b></li>
                        </ul>
                        {
                            status === "Waiting For Payment" ?
                                <Timer duration={seconds} onComplete={(duration) => {
                                    setTimeLeft(duration);
                                }} /> : <span />
                        }

                    </Grid>
                    <Grid item md={12} sm={12} xs={12}>
                        <ul id="log">
                        </ul>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}

export default Dashboard;
